import _ from 'lodash';

import { Plugins } from './lib/Plugins';
import config from '~/config';

const plugins = new Plugins();

config.on( 'plugin', ( name, conf ) => {
  const plugin = plugins.load( name, conf );
  if ( typeof plugin.onConfig === 'function' ) plugin.onConfig( config );
  return plugin;
} );

export default plugins;
